import { useTranslation } from '@govard/i18n-core/react';
import { useI18nSubscription } from '../../../i18n/useI18nSubscription.js';
import { i18n } from '../../../../i18n/index.js';
import type { ReactElement } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@govard/ui-primitives';
import type { StructuredMessagePayload } from '@govard/ai-chat-kit';

export function DealCallPreparationSnippet({
  preparation,
}: {
  preparation: Extract<StructuredMessagePayload, { type: 'deal_call_preparation' }>['preparation'];
}): ReactElement {
  useI18nSubscription();
  const { locale } = useTranslation();
  return (
    <Card data-testid="structured-snippet-deal-call-preparation" className="min-w-0">
      <CardHeader>
        <CardTitle>
          {i18n.t(
            'crm.features.features.ai.chat.components.snippets.dealcallpreparationsnippet.podgotovka_k_razgovoru',
          )}
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-4 text-sm">
        <div>
          <p className="font-medium">{preparation.deal.title}</p>
          <p className="text-muted-foreground">
            {preparation.deal.stage} ·{' '}
            {preparation.deal.amount.toLocaleString(locale === 'ru' ? 'ru-RU' : 'en-US')}{' '}
            {preparation.deal.currency}
            {preparation.contact ? ` · ${preparation.contact}` : ''}
          </p>
        </div>
        {preparation.tasks.length ? (
          <section>
            <p className="mb-1 font-medium">
              {i18n.t(
                'crm.features.features.ai.chat.components.snippets.dealcallpreparationsnippet.otkrytye_zadachi',
              )}
            </p>
            {preparation.tasks.map((item, index) => (
              <p key={`task-${index}-${item}`}>{item}</p>
            ))}
          </section>
        ) : null}
        {preparation.notes.length ? (
          <section>
            <p className="mb-1 font-medium">
              {i18n.t(
                'crm.features.features.ai.chat.components.snippets.dealcallpreparationsnippet.poslednie_zametki',
              )}
            </p>
            {preparation.notes.map((item, index) => (
              <p key={`note-${index}-${item}`} className="text-muted-foreground">
                {item}
              </p>
            ))}
          </section>
        ) : null}
        <section>
          <p className="mb-1 font-medium">
            {i18n.t(
              'crm.features.features.ai.chat.components.snippets.dealcallpreparationsnippet.chto_sprosit_klientu',
            )}
          </p>
          {preparation.questions.map((item, index) => (
            <p key={`question-${index}-${item}`}>
              {index + 1}. {item}
            </p>
          ))}
        </section>
        <p className="rounded-md bg-muted/40 p-3 text-xs text-muted-foreground">
          {i18n.t(
            'crm.features.features.ai.chat.components.snippets.dealcallpreparationsnippet.eto_tolko_podgotovka_dannye_crm_ne_izmenya',
          )}
        </p>
      </CardContent>
    </Card>
  );
}
